export default "__VITE_ASSET__BBBBibKz__"